import { observer } from 'mobx-react-lite'
import { RecordAudioModal } from 'widgets/RecordAudio'
import { type VoicemailDropStore } from 'pages/settings/pages/personal/pages/account/pages/voicemailDrop'

type IRecordAudioModalProps = {
  store: VoicemailDropStore
}

export const VoicemailRecordAudioModal = observer(({ store }: IRecordAudioModalProps) => (
  <RecordAudioModal recordAudioStore={store.recordAudioStore} onInit={store.initRecordAudio} />
))
